export default "__VITE_ASSET__sdvR3tpjwxgqtE4CD7BlUQ__"